import {CardObject, MnemoObject} from "../types.d";

export function approvedText(approved, disapproved) {
    if (approved) {
        return '(approved)';
    }

    if (disapproved) {
        return '(disapproved)';
    }

    return '';
}

export function escalationText(card: (CardObject | MnemoObject)) {
    if (card.approvedAt || (card.feedback && card.feedback === 1)) {
        return '(was correct)';
    }

    if (card.feedback && card.feedback !== 1) {
        return '(was incorrect)';
    }

    return '';
}
